<template>
    <main>
        <div class="row">
            <div class="col-12">
                <div class="tile">
                    <div class="form-inline">
                        <form-input class="mr-1 mb-2" :model="filterFormModel" attribute="keyword"
                            v-on:keydown.enter="load" :placeholder="$t('enterZaloID')"></form-input>
                        <client-select v-if="!clientId" class="mr-1 mb-2" :model="filterFormModel" attribute="client"
                            @change="search" :isFilter="true" :place-holder="$t('selectClient')"></client-select>
                        <social-net-work-account-select :model="filterFormModel" class="mr-1 mb-2" attribute="oa"
                            @change="search" :isFilter="true" :filter="oaFilter" :is-filter="true" />
                        <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-2" :options="[
                            { text: this.$t('zaloType'), value: null },
                            { text: this.$t('transactionMessage'), value: 'transaction' },
                            { text: this.$t('promotionMessage'), value: 'promotion' },
                            { text: this.$t('imageMessage'), value: 'image' },
                            { text: this.$t('csMessage'), value: 'cs' },
                            { text: this.$t('request_user_infoMessage'), value: 'request_user_info' },
                        ]"></form-select>
                        <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-2" :options="[
                            { value: null, text: $t('status') },
                            { value: 'sending', text: $t('notYetSent') },
                            { value: 'success', text: $t('success') },
                            { value: 'fail', text: $t('error') }
                        ]"></form-select>
                        <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2"
                            :defaultShortcut="3"></time-range-picker>
                        <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
                        <button @click="reset" class="btn btn-secondary mr-1 mb-2">{{ $t('reset') }}</button>
                        <history-export
                            v-if="['owner', 'admin', 'tech', 'operationsManager', 'account'].includes($store.state.user.role)"
                            :filter="filterFormModel" :total-count="itemCount" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount > 0">
                        {{ $t('found', [itemCount]) }}
                    </div>
                    <div class="c-paging__right">
                        <div class="c-paging__numbers">
                            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                                v-model="filterFormModel.page" :total-rows="itemCount"
                                :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="items.length > 0">
                <div class="c-smart-table tile">
                    <div class="row c-smart-table__title">
                        <div class="col-lg-3">{{ $t('from') }}</div>
                        <div class="col-lg-2">{{ $t('toID') }}</div>
                        <div class="col-lg-3">{{ $t('time') }}</div>
                        <div class="col-lg-4">{{ $t('content') }}</div>
                    </div>
                    <div class="row" v-for="item in items" :key="item._id">
                        <div class="col-lg-3">
                            <p v-if="item.client">
                                <b>{{ $t('client') }} : </b>
                                <span>{{ item.client.domain }}</span>
                            </p>
                            <p v-if="item.oa">
                                <b>Zalo OA : </b>
                                <span>{{ item.oa.name }}</span>
                            </p>
                            <p v-if="item.user">
                                <b>{{ $t('user') }}: </b>
                                <span>{{ item.user.name }} ({{ item.user.ext }})</span>
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <div v-if="item.zaloId">
                                {{ item.zaloId }}
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <p>
                                <b>{{ $t('createTime') }}:&nbsp;</b>
                                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                            </p>
                            <p v-if="item.sendTime">
                                <b>{{ $t('sendTime') }}:&nbsp;</b>
                                <span>{{ item.sendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                            </p>
                            <p>
                                <label class="badge badge-success" v-if="item.chargedFee && item.chargedFee > 0">
                                    {{ $t('chargedMessage') }}
                                </label>
                                <label class="badge badge-primary"
                                    v-else-if="item.quota && item.quota.total > 0 && !item.fromContact">
                                    {{ `${$t('message', [item.quota.type === 'day' ?
                            $t(item.quota.type).toLowerCase().slice(3) : $t(item.quota.type).toLowerCase()])}
                                    ${$t('free').toLowerCase()} ${$t('residual').toLowerCase()}
                                    ${item.quota.remain}/${item.quota.total}` }}
                                </label>
                            </p>
                        </div>
                        <div class="col-lg-4">
                            <p v-if="item.messageCampaign">
                                <b>{{ $t('messageCampaigns') }}: </b>
                                <span>{{ item.messageCampaign.name }} </span>
                            </p>
                            <p v-if="item.template">
                                <b>{{ $t('messageTemplate') }}: </b>
                                <span>{{ item.template.name }}</span>
                                <a v-if="item.template.previewUrl" :href="item.template.previewUrl" target="_blank"
                                    class="small">
                                    {{ $t('seeTemplate') }}
                                </a>
                            </p>
                            <p>
                                <b>{{ $t('type') }}: </b>
                                <span class="badge badge-primary">{{ $t(item.type + 'Message') }}</span>
                            </p>
                            <p>
                                <b>{{ $t('status') }}: </b>
                                <label class="badge badge-warning" v-if="!item.sendTime">{{ $t('notYetSent') }}</label>
                                <label class="badge badge-success" v-if="item.sendTime && !item.sendError">{{ $t('sent')
                                    }}</label>
                                <label class="badge badge-danger" v-if="item.sendTime && item.sendError">{{
                            $t('sentFail') }}</label>
                                &nbsp;<label v-if="item.sendErrorMsg">{{ item.sendErrorMsg
                                    }}</label>
                            </p>
                            <div v-if="item.developmentMode">
                                <span class="badge badge-secondary">Development mode</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center text-danger" v-if="items.length === 0 && !loading">{{
                            $t('notFoundSearch')
                        }}
            </div>
            <div class="col-12" v-if="itemCount > 0">
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount">
                        {{ $t('found', [itemCount]) }}
                    </div>
                    <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
                    </b-pagination>

                </div>
            </div>
        </div>
    </main>
</template>

<script>
import list from '@/mixins/List';
import utils from '@/utils';
import ClientSelect from "@/components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import HistoryExport from "./HistoryExport"
import SocialNetWorkAccountSelect from "@/components/SocialNetWorkAccountSelect";
import _ from 'lodash';
import moment from "moment";

export default {
    components: { TimeRangePicker, ClientSelect, HistoryExport, SocialNetWorkAccountSelect },
    props: {
        clientId: String,
    },
    mixins: [list, utils],
    data() {
        return {
            service: '/zalo-oa',
            autoLoad: true,
            oaFilter: {
                type: "zalo",
                client: null
            },
            defaultFilterFormModel: {
                client: this.clientId || null,
                keyword: null,
                type: null,
                status: null,
                from: moment().subtract('29', 'day').startOf('day').valueOf(),
                to: moment().endOf('day').valueOf(),
            }
        }
    },
    methods: {
        search: _.debounce(function () {
            this.filterFormModel.page = 1;
            this.load();
        }, 200),
    },
    i18n: {
        messages: {
            en: {
                from: 'Sent from',
                toID: 'Sent to Zalo ID',
                time: 'Time',
                content: 'Content',
                createTime: 'Create time',
                sendTime: 'Send time',
                chargedFee: 'Charged fee',
                messageCampaigns: "Message campaigns",
                messageTemplate: "Message template",
                chargedMessage: "Paid messages",
                seeTemplate: "See templates",
                smsType: 'Type',
                reset: 'Reset',
                message: "Message {0}",
                free: "Free",
                residual: "Still",
                notFoundSearch: "No results found!",
                transactionMessage: "Transaction news",
                promotionMessage: "Personal media news",
                imageMessage: "Consulting message with photo attached",
                request_user_infoMessage: "Request user Information",
                csMessage: "Consulting messages",
                reply: "Reply",
                month: "Month",
                notYetSent: 'Not yet sent',
                sent: "Sent",
                sentFail: "Sent failed",
                status: "Status",
                zaloType: "Zalo OA type",
                enterZaloID: "Enter Zalo ID",
                zalo: "Zalo OA",
                facebook: "Facebook",
            },
            vi: {
                from: 'Gửi từ',
                toID: 'Gửi tới Zalo ID',
                time: 'Thời gian',
                content: 'Nội dung',
                createTime: 'Tạo lúc',
                sendTime: 'Gửi lúc',
                messageTemplate: "Mẫu tin nhắn",
                messageCampaigns: "Chiến dịch gửi tin nhắn",
                seeTemplate: "Xem mẫu",
                chargedFee: 'Số tiền',
                chargedMessage: "Tin nhắn tính phí",
                smsType: 'Loại',
                reset: 'Đặt lại',
                message: "Tin nhắn {0}",
                free: "Miễn phí",
                residual: "Còn",
                notFoundSearch: "Không tìm thấy kết quả nào!",
                transactionMessage: "Tin giao dịch",
                promotionMessage: "Tin truyền thông cá nhân",
                imageMessage: "Tin nhắn tư vấn đính kèm ảnh",
                request_user_infoMessage: "Yêu cầu thông tin người dùng",
                csMessage: "Tin nhắn tư vấn",
                reply: "Trả lời",
                month: "Tháng",
                notYetSent: 'Chưa gửi',
                sent: "Đã gửi",
                sentFail: "Gửi thất bại",
                status: "Tình trạng",
                zaloType: "Phân loại Zalo OA",
                enterZaloID: "Nhập Zalo ID",
            }
        }
    }
}
</script>